function getCollectionLink(slug: string): string {
  return `/${slug}/`;
}

export { getCollectionLink };
